// LIBRERIE
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Presentation: React.FC = () => {
    const { t } = useTranslation();

    return (
        <section id="presentation">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12 col-lg-8">
                        <h2 className="text-center mb-5">{t("homePage.presentation.title")}</h2>
                        <div>
                            <p dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para1") as string}}></p>
                            <p className="mb-5" dangerouslySetInnerHTML={{ __html: t("homePage.presentation.para2") as string}}></p>
                            <Link to="/servizi" className="btn btn-primary" title={t("homePage.presentation.btnTitle") as string}>
                                {t("homePage.presentation.btnText")}
                            </Link>
                        </div>
                    </div>
                    <div className="col-12 col-lg-4 px-0 position-relative">
                        <div className="img-wrapper">
                            <img src="/assets/images/inHome/presentation1.webp" alt={t("homePage.presentation.img1Alt") as string} />
                        </div>
                        <img className="img-fluid absolute img-shadow" src="/assets/images/inHome/presentation2.webp" alt={t("homePage.presentation.img2Alt") as string} />
                    </div>
                </div>
            </div>
        </section>
    )
}
export default Presentation;